<template>
  <div class="faq">
    <van-search v-model="search" :placeholder="store.langConfig.SearchPlace" @search="onSearch"></van-search>
    <router-view :store="store" :search="search"></router-view>
  </div>
</template>

<script>
export default {
  name: 'Faq',
  props: {
    store: Object
  },
  data(){
    return {
      search: ''
    }
  },
  methods: {
    onSearch(){
      if (this.$route.path !== '/faq/detail') {
        this.$router.push({path: '/faq/detail'})
      } 
    }
  }
}
</script>


